<wr-new-data-table headerText="Protokolltypen"
                   [infoBanner]="catalogBanner()"
                   localStorageIdentifier="protocol-type-overview"
                   [loadItemsFunction]="loadItems"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToDetail($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="canCreate()">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input id="textFilter" type="text" nbInput formControlName="text" placeholder="Filter Text...">
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template dataColumn let-item key="shortcut" display="Kürzel">
    {{ item.shortcut }}
  </ng-template>
  <ng-template dataColumn let-item key="color" display="Farbe">
    <div class="color-swatch" [style.background]="item.color"></div>
  </ng-template>
  <ng-template dataColumn let-item key="name" display="Name">
    {{ item.name }}
  </ng-template>
</wr-new-data-table>
